import { render, staticRenderFns } from "./ChatNavbar.vue?vue&type=template&id=2c91e4de&scoped=true&"
import script from "./ChatNavbar.vue?vue&type=script&lang=js&"
export * from "./ChatNavbar.vue?vue&type=script&lang=js&"
import style0 from "./ChatNavbar.vue?vue&type=style&index=0&id=2c91e4de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c91e4de",
  null
  
)

export default component.exports